import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

// Render de markdown da wiki: marked → DOMPurify. Permite <video> (uploads da
// própria wiki) e bloqueia o resto do HTML perigoso.
export function Markdown({ source }: { source: string }) {
  const html = useMemo(() => {
    // Artigos do editor rico já são HTML; legados em markdown passam pelo marked.
    const raw = source.trimStart().startsWith("<")
      ? source
      : marked.parse(source, { async: false, gfm: true, breaks: true });
    return DOMPurify.sanitize(raw, {
      ADD_TAGS: ["video", "source"],
      ADD_ATTR: ["controls", "src", "type", "preload"],
    });
  }, [source]);

  return (
    <div
      className="wiki-md"
      style={{ fontSize: 14, lineHeight: 1.7, color: "var(--ink)", wordBreak: "break-word" }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
